/** @jsx h */
import { h } from 'preact'

const JourneyProgress = ({ total }) => {
  const steps = []
  for (let i = 0; i < total; i += 1) {
    steps.push(
      <div class='JourneyProgress-line' />
    )
  }

  return <div class='JourneyProgress'>{steps}</div>
}

export default JourneyProgress
